import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { AiScrubScope } from '../../models';

export const cancelAiScrubBatch: (
  fetchContext: FetchContext,
  awardId: number,
  batchRunId: string,
  accessToken?: string,
  scope?: AiScrubScope,
) => Promise<void> = (fetchContext, awardId, batchRunId, accessToken, scope = 'awards') =>
  fetch(`${fetchContext.baseUrl}/api/staff/${scope}/${awardId}/ai-scrub-batch/${encodeURIComponent(batchRunId)}/cancel`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'cancel AI scrub batch'));
